import { ComponentInstance, isVNode, VNode, VNodeArrayChildren, VNodeChild } from "vue";

export default function getRootElementsFromComponent<T>(component: ComponentInstance<T> | HTMLElement): HTMLElement[] {
  if(component instanceof HTMLElement) {
    return [component];
  }

  const rootElements: HTMLElement[] = [];
  let rootElement = component.$el as HTMLElement;
  const uidCtx = component.$.uid;
   // Ensure it's an element node
  if (rootElement.nodeType === Node.ELEMENT_NODE) {
    rootElements.push(rootElement);
    return rootElements;
  }

  rootElement = component.$.subTree.el as HTMLElement;
  if (rootElement && rootElement.nodeType === Node.ELEMENT_NODE) {
    rootElements.push(rootElement);
    return rootElements;
  }

 
  const childNodes = component.$.subTree.children;
  if (childNodes && Array.isArray(childNodes)) {
    childNodes.forEach((node) => {
      const child = node as VNode;
      if (isVNode(child) && child.el.nodeType === Node.ELEMENT_NODE) {
        rootElements.push(child.el as HTMLElement);
      }
    });
  }
  return rootElements;
}

export function containsElement<T>(component: ComponentInstance<T> | HTMLElement, targetElement: HTMLElement): boolean {
  if(!component) {
    return false;
  }
  const rootElements = getRootElementsFromComponent(component);
  for(const rootElement of rootElements) {
    if (rootElement.contains(targetElement)) {
      return true;
    }
  }
  return false;
}